import { VDivider } from 'vuetify/lib/components/VDivider';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VStepper,{attrs:{"alt-labels":"","max-height":"80px"},model:{value:(_vm.estado),callback:function ($$v) {_vm.estado=$$v},expression:"estado"}},[_c(VStepperHeader,[_vm._l((_vm.steps),function(n){return [_c(VStepperStep,{key:`${n}-step`},[_vm._v("\r\n    "+_vm._s(n)+"\r\n    ")]),(n !== _vm.steps)?_c(VDivider,{key:n}):_vm._e()]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }